export default __webpack_public_path__ + "static/media/heraldofxotli_icon.238d1d7b.png";